import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
import '../../assets/scripts/number.js'

// 首页轮播
var banner = new Swiper('.banner .swiper-container', {
	autoplay: {
        delay: 6000,
        disableOnInteraction: false,
	},
	speed:1000,
	loop:true,//必须
}); 

// 数字滚动
var istrue = true;
var s = $(window).scrollTop();
if (s > $(".section2").offset().top - $(".section2 .section-title").height() - $("header").height() && istrue) {
        $(".timer").each(count);
        function count(a) {
            var b = $(this);
            a = $.extend({},
            a || {},
            b.data("countToOptions") || {});
            b.countTo(a)
        };
        istrue = false;
    };
$(window).on("scroll",
function() {
   var s = $(window).scrollTop();
    if (s >$(".section2").offset().top - $(".section2 .section-title").height() - $("header").height() && istrue) {
        $(".timer").each(count);
        function count(a) {
            var b = $(this);
            a = $.extend({},
            a || {},
            b.data("countToOptions") || {});
            b.countTo(a)
        };
        istrue = false;
    };
})

